"use strict";
const forEach = require('lodash/forEach');
const isBoolean = require('lodash/isBoolean');
/**
 * Get sql where condition string to add to your query, according to the column = value you send.
 * And get also SET list if update params exist.
 * @param query object
 * @param updateValues object
 * @returns {{params: *[], whereList: string, updateList: string}}
 */
const buildQueryParams = (query, updateValues = {}) => {
    const whereList = [];
    const params = [];
    const updateList = [];
    forEach(updateValues, (value, key) => {
        if (value === null) {
            updateList.push(`${key} = NULL`);
        }
        else if (isBoolean(value)) {
            updateList.push(`${key} = ?`);
            params.push(value ? 1 : 0);
        }
        else {
            updateList.push(`${key} = ?`);
            params.push(value);
        }
    });
    forEach(query, (value, key) => {
        if (value === null) {
            whereList.push(`${key} IS NULL`);
        }
        else if (isBoolean(value)) {
            whereList.push(`${key} = ?`);
            params.push(value ? 1 : 0);
        }
        else if (Array.isArray(value)) {
            whereList.push(`${key} IN (?)`);
            params.push(value);
        }
        else {
            whereList.push(`${key} = ?`);
            params.push(value);
        }
    });
    return {
        whereList: whereList.join(' AND '),
        updateList: updateList.join(','),
        params,
    };
};
/**
 * Get sql date condition object to add to your query, according to the column and query params you send.
 * @param {{startDate: string, endDate: string}}
 * @returns {{params: *[], whereList: string}}
 */
const buildTimestampQuery = (column, { startDate, endDate }) => {
    const whereList = [];
    const params = [];
    if (startDate) {
        whereList.push(`${column} >= ?`);
        params.push(startDate);
    }
    if (endDate) {
        whereList.push(`${column} <= ?`);
        params.push(endDate);
    }
    return { whereList: whereList.join(' AND '), params };
};
/**
 * Get sql update string to add to your query, according to the column = value you send.
 * @param query object
 * @returns {{setList: string, params: unknown[]}}
 */
const buildUpdateQueryParams = (query) => {
    const setList = Object.keys(query).map((key) => (`${key} = ?`));
    const params = Object.values(query);
    return {
        setList: setList.join(', '),
        params,
    };
};
/**
 * Get sql insert strings to add to your query, according to the column = value you send.
 * @param query object
 * @returns {{valuesList: string, params: string[], columnsList: string}}
 */
const buildInsertParamsAndValues = (query) => {
    const params = Object.values(query);
    const values = new Array(params.length).fill('?');
    const keys = Object.keys(query);
    return {
        params,
        columnsList: `(${keys.join(', ')})`,
        valuesList: `(${values.join(', ')})`,
    };
};
module.exports = {
    buildQueryParams,
    buildTimestampQuery,
    buildUpdateQueryParams,
    buildInsertParamsAndValues,
};
//# sourceMappingURL=mySql.js.map